(function () {
    'use strict';

    angular
        .module('elogbooks.admin.service-providers')
        .controller('ServiceProviderInfoController', ServiceProviderInfoController);

    ServiceProviderInfoController.$inject = ['serviceProviderResponse', 'modulesService', 'elbSettings'];

    function ServiceProviderInfoController (serviceProviderResponse, modulesService, elbSettings) {
        var vm = this;
        vm.serviceProvider = serviceProviderResponse;
        vm.p2pEnabled = modulesService.isEnabled('p2p');
        vm.safecontractorEnabled = modulesService.isEnabled('safecontractor');
        vm.prosureEnabled = !!elbSettings.getSetting('prosure_enabled').value;
        vm.assetsModuleEnabled = modulesService.isEnabled('assets_module');
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');

        if (vm.serviceProvider.ppmReminderAlertOption === 'statutory') {
            vm.ppmReminderAlertText = 'PPM_REMINDER_STATUTORY_ONLY';
        } else if (vm.serviceProvider.ppmReminderAlertOption === 'all') {
            vm.ppmReminderAlertText = 'PPM_REMINDER_ALL';
        } else {
            vm.ppmReminderAlertText = 'PPM_REMINER_DISABLED';
        }
    }
})();
